<!-- routify:options param-is-page=true -->
<script lang="ts">
  import ShowPage from "@modern/components/retailer/deals/Show.svelte";
  import DealError from "@modern/components/retailer/deals/DealError.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import { params } from "@roxi/routify";

  const dealRes = async () => {
    let res = await HttpPromise({
      method: "GET",
      url: `/api/retailer/deals/show_from_happy_hour`,
      data: {
        distributor_id: $params.distributorId,
        product_group_id: $params.productGroupId,
      },
    });
    return res;
  };
  const load = async () => {
    await RetailerFulfillmentMethodsStore.refreshFulfillmentMethods();
    let results = await dealRes();
    return {
      ...results,
    };
  };
</script>

{#await load()}
  <Spinner />
{:then data}
  {#if !data.deal?.tiers?.length}
    <div class="fizz-styles">
      <DealError />
    </div>
  {:else}
    <ShowPage {data} />
  {/if}
{:catch error}
  <div class="fizz-styles">
    <DealError />
  </div>
{/await}
